module.exports = __webpack_public_path__ + "static/media/3-nuclear-intro.f77731a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3-nuclear-intro.svg
// module id = 749
// module chunks = 3